import { Box, Divider, IconButton, Modal, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import CloseIcon from '@mui/icons-material/Close';
import { FormCreateOrEditHotelIntegration } from '../FormCreateOrEditHotelIntegration/index';
import { HotelSupplier } from '@bandido/shared/interfaces';

interface Props {
  open: boolean;
  onClose: () => void;
  suppliers: HotelSupplier[];
}

export const CreateHotelIntegrationModal = ({ open, onClose, suppliers }: Props) => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Modal open={open} onClose={onClose} aria-labelledby={t('hotelIntegrations.create.title')}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 400,
          bgcolor: 'background.paper',
          boxShadow: theme.shadows[1],
          p: 3,
          borderRadius: 2,
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
        }}
      >
        <Box display="flex" gap={2}>
          <Box flexGrow={1} display="flex" alignItems="center" gap={1}>
            <Typography id="create-hotel-integrations-modal-title" variant="h6" component="h2">
              {t('hotelIntegrations.create.title')}
            </Typography>
          </Box>
          <IconButton onClick={onClose}>
            <CloseIcon color="primary" />
          </IconButton>
        </Box>
        <Divider />
        <FormCreateOrEditHotelIntegration onClose={onClose} suppliers={suppliers} />
      </Box>
    </Modal>
  );
};
